export class MessageAttachment {
  public AttachementId: number = 0;
  public MessageId: number = 0;
  public AttachementPath: string = '';
  public FileName: string = '';
  public ContentId: number = 0;
}
